// eslint-disable-next-line
export function formatCommentText(comment) {
  if (!comment) return ''
  const translationFormatRegexp = /(\(Translated by Google\)|\(Original\))/g
  const formatted = comment.replace(translationFormatRegexp, '\n$1:\n').trim()
  return formatted.replace(/\n{2,}/g, '\n')
}
